import React, { ComponentType, useContext, useState } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import { useMediaQuery } from 'react-responsive';
import UserTileContext from '../../../contexts/userTilesContext';
import { ISelectableModuleTile, IProgramListSelectProps, IModule } from '../../../interfaces/interfaces';
import { getModuleComponents } from '../../../modules';
import Checkbox from '../Checkbox/Checkbox';

function ProgramListSelect(props: IProgramListSelectProps): JSX.Element {
  const { program, onChange, hideHeadline } = props;
  const { tiles, displayNumber } = program;
  const userTiles = useContext(UserTileContext);
  const modulesWComponents = getModuleComponents(userTiles.modules);

  const [carouselValue, setCarouselValue] = useState(0);
  const onChangeCarousel = (value: number) => {
    setCarouselValue(value);
  };

  const renderItems = (Wrap: ComponentType | keyof JSX.IntrinsicElements) => {
    return tiles?.map((tile: ISelectableModuleTile) => {
      const cbId = `${program.id}-${tile.tileRefId}`;
      const moduleName = tile.module;
      const module: IModule = modulesWComponents[moduleName];

      if (!module || !module.previewComponent) {
        return <>Module-Vorschau nicht verfügbar</>;
      }

      const moduleProps = { ...module.defaultProps, ...tile.props, ...tile.preview };
      moduleProps.className = moduleName;
      moduleProps.badgeText = program.number;

      return (
        <Wrap key={tile.id} className={`program-list-item ${tile.isSelected && 'selected'}`}>
          {/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ] */}
          <label htmlFor={cbId}>
            <div className="tile-preview-wrap">
              <div className={`tile-preview ${tile.module}`}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <module.previewComponent {...moduleProps} tileId={tile.tileRefId} badgeText={displayNumber} />
              </div>
              <Checkbox
                id={cbId}
                checked={tile.isSelected}
                onChange={(state) => {
                  if (onChange) {
                    onChange(tile, state);
                  }
                }}
              />
            </div>
          </label>
          <h5 className="hl-5">{tile.preview?.headline}</h5>
          <p className="tx_1">{tile.preview?.description}</p>
        </Wrap>
      );
    });
  };
  const isSmall = useMediaQuery({ query: '(max-width: 640px)' });
  return (
    <>
      {hideHeadline !== true && <h5 className="subtitle hl-5">Modul zum Produkt auswählen</h5>}
      {isSmall ? (
        <>
          <div className="program-tile-list">
            <Carousel value={carouselValue} onChange={onChangeCarousel}>
              {renderItems('div')}
            </Carousel>
            <div className="carousel-nav">
              <button
                type="button"
                className="button"
                disabled={carouselValue <= 0}
                onClick={() => {
                  onChangeCarousel(carouselValue - 1);
                }}
              >
                <span className="ic-arrowLeft" />
              </button>
              <span>
                {carouselValue + 1} / {tiles?.length}
              </span>
              <button
                type="button"
                className="button"
                disabled={carouselValue >= (tiles?.length || 0) - 1}
                onClick={() => {
                  onChangeCarousel(carouselValue + 1);
                }}
              >
                <span className="ic-arrowRight" />
              </button>
            </div>
          </div>
        </>
      ) : (
        <ul className="program-tile-list">{renderItems('li')}</ul>
      )}
    </>
  );
}
export default ProgramListSelect;
